import MARY from './company';

/**
 * Mary's registration: the base admin. No page is replaced, no route removed or added.
 */
const MaryRegistration = Object.freeze({
    ...MARY,
    pages: Object.freeze({}),
    extraRoutes: Object.freeze([]),
    remove: Object.freeze([]),
});

export default MaryRegistration;
